// Experiment:
// https://ab.daylight.stitchfix.com/expts/1792
export const frontDoorOfferExp = {
  expectedValues: ['no_promo', 'standard', 'percentage'],
  fallbackValue: 'standard',
  name: 'fy27-q1-fd-offer-experiment'
};

// Experiment:
// https://ab.daylight.stitchfix.com/expts/1611
export const variantExp = {
  expectedValues: ['promo-dark', 'grapefruit', 'forest', 'citrus'],
  fallbackValue: 'promo-dark',
  name: 'eng.incentives.holiday_slim_banner_variant_2025'
};